<div class="bmc-time-details" *ngIf="customWorkingHour">
    <div class="bmc-time-details__header bz-space--inset-m">
        <h4 class="bmc-time-details__header__text bz-font-weight--semibold" *ngIf="!editedHours"> {{ 'WORKING_TIME_SCHEMA.TIME_DETAILS' | translate}}</h4>
        <h4 class="bmc-time-details__header__text bz-font-weight--semibold" *ngIf="editedHours"> {{ 'WORKING_TIME_SCHEMA.LEYEND_EDITED_HOURS' | translate}}</h4>
        <div *ngIf="showClose" class="bmc-time-details__header__close" (click)="this.onClose.emit();">
            <svg class="bmc-time-details__header__close__icon bz-icn bz-icon-svg--16">
                <use href="#icon-close"></use>
            </svg>
        </div>
    </div>
    <div class="bmc-time-details__times" *ngIf="isCustom">
        <div class="bmc-time-details__times__titles">
            <h5 class="bmc-time-details__times__item bz-font-weight--semibold bz-space--stack-xs">{{ 'GLOBAL.FROM' | translate}}</h5>
            <h5 class="bmc-time-details__times__item bz-font-weight--semibold bz-space--stack-xs">{{ 'GLOBAL.TO' | translate}}</h5>
        </div>
        <div *ngIf="customWorkingHour.fromTime1 && customWorkingHour.toTime1" class="bmc-time-details__times__hours">
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.fromTime1 | date:'hh:mm a'}}</h5>
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.toTime1 | date:'hh:mm a'}}</h5>
        </div>
        <div *ngIf="customWorkingHour.fromTime2 && customWorkingHour.toTime2" class="bmc-time-details__times__hours">
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.fromTime2 | date:'hh:mm a'}}</h5>
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.toTime2 | date:'hh:mm a'}}</h5>
        </div>
        <div *ngIf="customWorkingHour.fromTime3 && customWorkingHour.toTime3" class="bmc-time-details__times__hours">
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.fromTime3 | date:'hh:mm a'}}</h5>
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.toTime3 | date:'hh:mm a'}}</h5>
        </div>
        <div *ngIf="customWorkingHour.fromTime4 && customWorkingHour.toTime4" class="bmc-time-details__times__hours">
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.fromTime4 | date:'hh:mm a'}}</h5>
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.toTime4 | date:'hh:mm a'}}</h5>
        </div>
        <div *ngIf="customWorkingHour.fromTime5 && customWorkingHour.toTime5" class="bmc-time-details__times__hours">
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.fromTime5 | date:'hh:mm a'}}</h5>
            <h5 class="bmc-time-details__times__item bz-space--stack-m">{{customWorkingHour.toTime5 | date:'hh:mm a'}}</h5>
        </div>
    </div>

  <div class="bmc-time-details__times" *ngIf="!isCustom">
    <div class="bmc-time-details__times__titles">
      <h5 class="bmc-time-details__times__item bz-font-weight--semibold bz-space--stack-xs">{{ 'GLOBAL.FROM' | translate}}</h5>
      <h5 class="bmc-time-details__times__item bz-font-weight--semibold bz-space--stack-xs">{{ 'GLOBAL.TO' | translate}}</h5>
    </div>
    <div *ngFor="let time of customWorkingHour" class="bmc-time-details__times__hours">
      <h5 class="bmc-time-details__times__item bz-space--stack-m">{{time.from}}</h5>
      <h5 class="bmc-time-details__times__item bz-space--stack-m">{{time.to }}</h5>
    </div>
  </div>
</div>
